export class Category {

  public name: string;
  public slug: string;

  public constructor ({ name, slug } : { name: string, slug: string }) {
    this.name = name;
    this.slug = slug;
  }

}
